<template>
  <div v-if="offersColumns" class="tender-offers-page">
    <div
      v-if="offersLength"
      class="tender-summary-offers-table incoming-tender-offers-table"
      :style="{
        'grid-template-columns': `220px repeat(${offersColumns.length}, 180px)`,
      }"
    >
      <IncomingOffersLegend :tender-offers="incomingTenderVersionsInfo" />
      <div class="d-contents">
        <div
          v-for="(offer, columnIndex) in offersColumns"
          :key="offer.id"
          class="offers-column offers-table-column_values"
          :class="{
            'offers-table-column_selected': selectedVersion && selectedVersion.id === offer.id,
          }"
        >
          <IncomingTenderVersionColumn
            :offer="offer"
            :tender-offers="incomingTenderVersionsInfo"
            :column-index="columnIndex"
            :rows-count="rowsCount"
          />
        </div>
      </div>
    </div>
    <div
      class="tender-offers-page__total"
      :style="{
        'grid-template-columns': `220px repeat(${offersColumns.length}, 180px)`,
      }"
    >
      <span
        class="offers-table-cell__total offers-table-cell__total_main text-sm offers-table-cell_sticky grey-900"
      >
        {{ $t('Total price') }}
      </span>
      <div
        v-for="(offer, idx) in offersColumns"
        :key="idx"
        class="text-sm offers-table-cell__total offers-table-cell__total-title spacex-4"
        :class="{
          'offers-table-cell_disabled': offer.status === 'old' || offer.status === 'disabled',
        }"
      >
        <span v-if="offer.final_budget" class="table-cell-currency">
          {{ currencySymbols[incomingTenderVersionsInfo.currency] }}
        </span>
        <span v-if="offer.final_budget" class="grey-900">
          {{ addSpaces(offer.final_budget) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '@/router';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import IncomingTenderVersionColumn from '@/containers/incoming-tender/incoming-tender-offers-table/IncomingTenderVersionColumn';
  // import NewOfferWindow from '@/components/incoming-tender/modals/NewOfferWindow';
  import NoTaxesConfirm from '@/components/incoming-tender/NoTaxesConfirm';
  import SubmitOfferDescriptionModal from '@/components/incoming-tender/modals/SubmitOfferDescriptionWindow';
  import IncomingOffersLegend from '@/containers/incoming-tender/incoming-tender-offers-table/IncomingOffersLegend';
  import addSpaces from '@/utils/formatting/add-spaces';
  import TENDER_OFFER_VERSION_STATUSSES from '@/utils/constants/tender-offer-version-statuses';

  const COUNT_OF_DEFAULT_GRID_ROWS = 6;

  export default {
    name: 'IncomingTenderOffersPage',
    components: {
      IncomingTenderVersionColumn,
      IncomingOffersLegend,
      // eslint-disable-next-line vue/no-unused-components
      SubmitOfferDescriptionModal,
    },
    data() {
      return {
        loading: true,
        COUNT_OF_DEFAULT_GRID_ROWS,
      };
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
      ...mapState('incomingTender', [
        'incomingTenderVersions',
        'incomingTenderInfo',
        'selectedVersion',
        'exportErrorUpdateTrigger',
        'showOldAndArchivedOffers',
        'incomingTenderVersionsInfo',
      ]),
      ...mapGetters({
        hideSubmitDraftWindow: 'incomingTender/versionCanBeAdded',
        draftEmptyPositions: 'incomingTender/draftEmptyPositions',
        draftVersion: 'incomingTender/draftVersion',
      }),
      offersLength() {
        return this.incomingTenderVersions.length;
      },
      rowsCount() {
        return this.incomingTenderVersionsInfo?.lists?.length || 0;
      },
      offersColumns() {
        return this.showOldAndArchivedOffers
          ? this.incomingTenderVersions
          : this.incomingTenderVersions.filter(
              (version) => version.status !== 'old' && version.status !== 'archived'
            );
      },
      draftName() {
        const draftVersion = this.incomingTenderVersions.find(
          (version) => version.status === TENDER_OFFER_VERSION_STATUSSES.draft
        );
        return draftVersion ? draftVersion.name : '';
      },
    },
    methods: {
      addSpaces,
      ...mapActions('incomingTender', [
        'loadIncomingTenderVersions',
        'createIncomingTenderVersion',
        'submitOfferVersion',
        'uploadXlsxTemplate',
      ]),
      ...mapActions('modal', ['openModal']),
      async loadVersions() {
        this.loading = true;
        const incomingTenderId = router.currentRoute.params.incomingTenderId;
        await this.loadIncomingTenderVersions({ incomingTenderId });
        this.loading = false;
      },
      submitOfferVersionHandler() {
        if (!this.draftVersion.taxes.length) {
          this.openModal({
            component: NoTaxesConfirm,
            context: {
              emitter: () => {
                this.showVersionDescriptionHandler();
              },
            },
          });
        } else {
          this.showVersionDescriptionHandler();
        }
      },
      showVersionDescriptionHandler() {
        this.openModal({
          component: SubmitOfferDescriptionModal,
          context: {
            emitter: (description) => {
              this.submitOfferVersion({
                incomingTenderId: this.incomingTenderInfo.id,
                description,
              });
            },
          },
        });
      },
    },
    watch: {
      '$route.params.incomingTenderId': function () {
        this.loadVersions();
      },
    },
    created() {
      this.loadVersions();
    },
  };
</script>
